(ns manatee.auth.handlers
  (:require
   [ajax.core :refer [json-request-format json-response-format]]
   [cemerick.url :refer [url]]
   [kee-frame.core :as kf]
   [manatee.app-db :as app-db]
   [manatee.auth.app-db :as auth-db]
   [manatee.auth.ids :as ids]
   [manatee.components.notifications.handlers :as notifications]
   [manatee.session.handlers :as session]
   [manatee.user.app-db :as user-db]
   [manatee.user.handlers :as user]
   [medley.core :as medley]
   [re-frame.core :as rf]))

(rf/reg-event-fx
 ::auth-success-redirect
 (fn auth-success-redirect
   [_ [_ redirect-uri]]
   {:redirect-to redirect-uri}))

(rf/reg-event-fx
 ::validate-user
 [(rf/inject-cofx :current-url)]
 (fn validate-user
   [{:keys [db current-url]} [_ {:keys [token] :as response}]]
   (let [{:keys [cookies]} (app-db/get-config db)
         status (user-db/get-status db)
         redirect-uri (str (url current-url (user-db/get-user-landing-page db)))]
     (case status
       :logging-in
       {:dispatch-n [[::validate-user response]
                     [::user/load-user token]]}

       :loading-user
       {:dispatch [::validate-user response]}

       :success
       {:cookie/set [(medley/remove-vals nil? {:domain (:domain cookies)
                                               :name "auth-token"
                                               :value token
                                               :secure (:allow-secure? cookies)})]
        :dispatch [::session/log-events {:events [{:event-type :sign-in}]
                                         :on-success [::auth-success-redirect redirect-uri]}]}
       ;; Error or default status
       {:dispatch [::sign-in-failure]}))))

(rf/reg-event-db
 ::set-login-email
 (fn set-login-email
   [db [_ login-email]]
   (auth-db/set-login-email db login-email)))

(rf/reg-event-db
 ::set-login-password
 (fn set-login-password
   [db [_ login-password]]
   (auth-db/set-login-password db login-password)))

(rf/reg-event-db
 ::clear-login-form
 (fn clear-login-form
   [db [_]]
   (auth-db/clear-login-form db)))

(rf/reg-event-db
 ::set-email-dirty
 (fn set-email-dirty
   [db [_ b]]
   (auth-db/set-email-dirty db b)))

(rf/reg-event-db
 ::set-password-dirty
 (fn set-password-dirty
   [db [_ b]]
   (auth-db/set-password-dirty db b)))

(rf/reg-event-fx
 ::sign-in
 [(rf/inject-cofx :current-url)
  (rf/inject-cofx :path-for :gateway)]
 (fn sign-in
   [{:keys [db current-url path-for]} [_]]
   (let [account-id (app-db/account-id db)
         {:keys [email password]} (auth-db/get-login-payload db)
         redirect-uri (str (url current-url "/annotate"))]
     {:db (user-db/set-status db :logging-in)
      :dispatch [::clear-login-form]
      :http-xhrio {:method :post
                   :uri (-> (url (path-for :gateway/login))
                            (assoc :query {:redirect-uri redirect-uri}))
                   :headers {:x-account-id account-id}
                   :params {:email-or-username email :password password}
                   :format (json-request-format)
                   :response-format (json-response-format {:keywords? true})
                   :on-success [::validate-user]
                   :on-failure [::sign-in-failure]}})))

(rf/reg-event-fx
 ::sign-in-failure
 (fn sign-in-failure
   [{:keys [db]} [_ _]]
   {:db (user-db/set-status db :error)
    :dispatch [::notifications/add-alert ids/login-alert-banner
               {:message "Check the email address and password are correct and try again."
                :type :error}
               :auto-dismiss? true]}))

(rf/reg-event-fx
 ::remove-auth-cookie
 (fn
   [{:keys [db]} _]
   {:cookie/remove {:domain (app-db/cookies-domain db) :name :auth-token}
    :db (user-db/remove-user db)
    :redirect-to (kf/path-for [:manatee.auth.handlers/login])}))

(rf/reg-event-fx
 ::sign-out
 [(rf/inject-cofx :cookie/get [:auth-token])]
 (fn sign-out
   [{cookies :cookie/get} _]
   (when (:auth-token cookies)
     {:dispatch [::session/log-events {:events [{:event-type :sign-out}]
                                       :on-success [::remove-auth-cookie]
                                       :on-failure [::remove-auth-cookie]}]})))
